import React from 'react'
import { cn } from '@utils/cn'

interface LoadingSpinnerProps {
    size?: 'small' | 'medium' | 'large'
    className?: string
    color?: 'primary' | 'accent' | 'white'
}

const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
}

const colorClasses = {
    primary: 'text-primary-600',
    accent: 'text-accent-500',
    white: 'text-white'
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = 'medium',
    className,
    color = 'primary'
}) => {
    return (
        <div className={cn('flex items-center justify-center', className)}>
            <div
                className={cn(
                    'animate-spin rounded-full border-2 border-transparent border-t-current',
                    sizeClasses[size],
                    colorClasses[color]
                )}
                role="status"
                aria-label="Cargando..."
            >
                <span className="sr-only">Cargando...</span>
            </div>
        </div>
    )
}

export default LoadingSpinner